import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"


interface IDetalheEstado {

    codigo: number;
    nome: string;
    sigla: string;
    codRegiao: number;
}

interface IListagemEstados {
    codigo: number;
    nome: string;
    sigla: string;
    codRegiao: number

}

export interface IDadosRetornoEstado {
    dado: IListagemEstados[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetorno {
    dado: IListagemEstados[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

type TEstadosComTotalCount = {
    data: IDadosRetorno;
    totalCount: number;
}


const getAll = async (page = 1, filter = '', id = 0): Promise<TEstadosComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get("/estado", {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: id > 0 ? id : null,
            NumeroPagina: page,
            TamanhoPagina: 27,
            Filtro: null,
            Filtro2: filter
        }
    });
    
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getById = async (codigo: number): Promise<IDetalheEstado | Error> => {
    try {
        const token = CookieService.get("access_token");
        const { data } = await Api.get<IDetalheEstado>(`/estado/${codigo}`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            },
        });
        if (data) {
            return data;
        }
        return new Error("Erro ao carregar o estado");

    } catch (error) {        
        return new Error((error as { message: string }).message || "Erro ao carregar o estado");
    }
}

const Create = async (dados: Omit<IDetalheEstado, "codigo">): Promise<number | Error> => {
    try {
        const token = CookieService.get("access_token");
        const { data } = await Api.post<IDetalheEstado>(`/estado`, dados, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            },
        });
        if (data) {
            return data.codigo;
        }
        return new Error("Erro ao cadastrar o estado");

    } catch (error) {        
        return new Error((error as { message: string }).message || "Erro ao cadastrar o estado");
    }
}

const updateById = async (codigo: number, dados: IDetalheEstado): Promise<void | Error> => {
    try {
        const token = CookieService.get("access_token");
        await Api.put<IDetalheEstado>(`/estado/${codigo}`, dados, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            },
        });
    } catch (error) {        
        return new Error((error as { message: string }).message || "Erro ao atualizar o estado");
    }

}

const deleteById = async (codigo: number): Promise<void | Error> => {
    try {
        const token = CookieService.get("access_token");
        await Api.delete(`/estado/${codigo}`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            },
        });
    } catch (error) {        
        return new Error((error as { message: string }).message || "Erro ao excluir o estado");
    }
}

export const EstadoService = {

    getAll,
    getById,
    Create,
    updateById,
    deleteById
}